/* tslint:disable:no-shadowed-variable */

import { environment as dev } from '../../../environments/environment.dev';
import { environment_PROD as prod } from '../../../environments/environment.prod';
import { environment_QA as qa } from '../../../environments/environment.qa';
import { environment_Local as local } from '../../../environments/environment.local';
import { Inject, Injectable, InjectionToken } from '@angular/core';

declare var window: any;

export const environments = {
  default: local,
  dev: dev,
  prod: prod,
  qa: qa
};

export interface EnvironmentConfigurationSettings {
  [setting: string]: any;
}

export interface EnvironmentConfigurations {
  default: EnvironmentConfigurationSettings;
  [environment: string]: EnvironmentConfigurationSettings;
}

export const Environments = new InjectionToken<EnvironmentConfigurations>('Environments');

@Injectable()
export class EnvironmentConfiguration implements EnvironmentConfigurationSettings {
  [setting: string]: any;

  constructor(@Inject(Environments) environments: EnvironmentConfigurations) {
    console.log('host '+window.location.hostname);
	let originUrl = window.location.href;
    if (originUrl.includes('event-view-details/')){
      sessionStorage.setItem("landingPage",'eventDetails');
      let id = originUrl.split('/').pop();
      localStorage.setItem('eventId',id);
    }  
    else if(originUrl.includes('take-survey/')){
      sessionStorage.setItem("landingPage",'takeSurvey');
      let id = originUrl.split('/').pop();
      localStorage.setItem('surveyId',id);
    }
    else if(originUrl.includes('membership/site')){
      sessionStorage.setItem("landingPage",'membershipSite');
    }
    else{
     
    }
    //let hostname1 = 'www.bpg.toyota.com';
    let hostname1 = (window.location && window.location.hostname) ? window.location.hostname.toLowerCase() : null;
    const hostname = hostname1.replace('www.','');
    let environmentType = environments.default;

    const environmentNames: string[] = Object.keys(environments).filter(envName => envName !== 'default');
    let selectedEnvName = environmentNames.find(envName => {
      if (environments[envName] && environments[envName].hostname) {
        return environments[envName].hostname.toLowerCase() === hostname;
      } else {
        return false;
      }
    });


    // Override default behavior by setting window.environment in index.html
    if (window['environment'] && environments[window['environment']]) {
      selectedEnvName = window['environment'];
    }

    if (!selectedEnvName) {
      selectedEnvName = 'default';
    } else if (selectedEnvName && environments[selectedEnvName]) {
      environmentType = environments[selectedEnvName];
    }

    environmentType.envName = selectedEnvName;

    Object.assign(this, environmentType);
  }
}
